<app-modal-base [title]="dialogTitle" [cancelType]="data.validateMode ? 'CANCEL' : 'CLOSE'"
  [hasSubmit]="data.validateMode" (onSubmitEvent)="docValidated()">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <div class="viewer">
      <ng2-pdfjs-viewer [pdfSrc]="docUrl" [downloadFileName]="docFilename" [print]="false" [download]="false"
        [openFile]="false" [viewBookmark]="false" [useOnlyCssZoom]="true" [fullScreen]="false"
        (onDocumentLoad)="onDocumentLoad($event)" viewerId="DocPdfViewer"></ng2-pdfjs-viewer>
      <div *ngIf="loading" class="loading">
        <div>Chargement en cours...</div>
        <div class="spinner"><mat-spinner [diameter]="20" color="primary"></mat-spinner></div>
      </div>
    </div>
  </div>
</ng-template>